import { isHomeTheme } from '@controllers/themeController.js';

const isHomeSite = isHomeTheme();

// --------------------Header Fixes----------------------//

function searchBoxPlaceholder() {
  const searchInput = $('header .inputFieldTextbox');
  // set a placeholder to searchInput
  searchInput.attr('placeholder', 'Type here...');
}

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const bars = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="26" height="24" class="mobile-nav-toggle__svg"><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg>`;
  navToggle.html(bars);
  navToggle.attr('tabindex', '0');
  navToggle.attr('role', 'button');
  navToggle.attr('aria-label', 'open menu');
}

function modifyHeader() {
  searchBoxPlaceholder();
  modifyBtnNavToggle();
}

// --------------------Lineup modifier----------------------//

function modifyFeatureLineup() {
  function lineupButtonsGrid(lineup) {
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    if (icons.width() + buttons.width() > containerSize - 20) {
      buttonContainer.addClass('column');
    }

    // remove icons if there 0 children
    if (!icons.children().length) {
      icons.remove();
    }
  }

  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);
    lineupButtonsGrid($element);
  });
}

$(document).ready(() => {
  $('.generalmessage').prependTo('header');
  modifyHeader();

  if (!isHomeSite) {
    modifyFeatureLineup();
  }
});
